var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79492 51.5871C6.79492 60.5146 9.4332 69.2415 14.3761 76.6644C19.3191 84.0873 26.3446 89.8728 34.5644 93.2892C42.7842 96.7055 51.829 97.5994 60.5551 95.8578C69.2812 94.1161 77.2966 89.8171 83.5878 83.5045C89.8789 77.1918 94.1632 69.149 95.899 60.3931C97.6347 51.6372 96.7439 42.5615 93.3391 34.3136C89.9344 26.0657 84.1686 19.0162 76.771 14.0563C69.3734 9.09651 60.6762 6.44922 51.7791 6.44922C39.8486 6.44922 28.4067 11.2048 19.9705 19.6698C11.5343 28.1348 6.79492 39.6158 6.79492 51.5871ZM26.0739 48.363H65.1137L47.1843 30.2853L51.7791 25.794L77.4844 51.5871L51.7791 77.3802L47.1843 72.7794L65.1137 54.8113H26.0739V48.363Z",
    fill: "#ECDBCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow2);
export default __webpack_public_path__ + "static/media/next-arrow2.e0e017b1897943eab03816626cf678ed.svg";
export { ForwardRef as ReactComponent };